import { render, staticRenderFns } from "./SampleRequestedBody.vue?vue&type=template&id=97893672&"
import script from "./SampleRequestedBody.vue?vue&type=script&lang=js&"
export * from "./SampleRequestedBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports